import { GameId } from '@common'

import { OnboardingModal } from './components/OnboardingModal'
import { Screen1, Screen2, Screen3, Screen4, Screen5 } from './screens/clash-of-clans'

const screens = [Screen1, Screen2, Screen3, Screen4, Screen5]

const enabledGames = ['clashofclans']

export const Onboarding = ({ gameId }: { gameId: GameId }) => {
  if (!enabledGames.includes(gameId)) {
    return null
  }

  return <OnboardingModal gameId={gameId} screens={screens} />
}
